import React from 'react';
import './App.css';

export default function Loader() {
    return (
        <div class="loader-container">
            <div class="lds-dual-ring"/>
        </div>
    );
}
